import { FeatureCollection } from 'geojson';
import { Layer } from '../../model';

const URL = 'https://photon.komoot.io/';

const search = (query: string, layers?: Layer[], bbox?: number[]): Promise<FeatureCollection> => {
  let url = `${URL}/api/?q=${query}&lang=en`;
  if (layers?.length) {
    layers.forEach((x) => (url += `&layer=${x}`));
  }

  if (bbox?.length) {
    url += `&bbox=${bbox.join(',')}`;
  }

  url += '&limit=100';

  return fetch(url).then((response) => response.json());
};

const reverse = (coords: [number, number]): Promise<FeatureCollection> => {
  const url = `${URL}/reverse?lon=${coords[0]}&lat=${coords[1]}&lang=en`;
  return fetch(url).then((response) => response.json());
};

export const geocodingService = {
  search,
  reverse,
};
